import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import {
  LayoutPlugin, DropdownPlugin,
  NavPlugin, NavbarPlugin, ButtonPlugin,
  TablePlugin, CollapsePlugin
} from 'bootstrap-vue'

import VueGtag from "vue-gtag";


Vue.config.productionTip = false

Vue.use(LayoutPlugin)
Vue.use(DropdownPlugin)
Vue.use(NavPlugin)
Vue.use(NavbarPlugin)
Vue.use(ButtonPlugin)
Vue.use(TablePlugin)
Vue.use(CollapsePlugin)

Vue.use(VueGtag, {
  bootstrap: false
}, router);


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
